/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Grid, Paper, Typography, Button, CircularProgress } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import {
    Link
} from "react-router-dom";

import { withRouter } from "react-router-dom";
/**
 * region for redux*/
import { connect } from 'react-redux';
import { MiniSitesActions } from '../../actions/MiniSitesActions';

/**
 * region for styles*/
import { updateMiniSiteStyle } from './style/updateMiniSiteStyle';

/**
 * region for componets*/
import BasicDetailsName from '../../components/minisites/common/BasicDetailsName';
import BasicDetailsSubDomain from '../../components/minisites/common/BasicDetailsSubDomain';
import BasicDetailsDomain from '../../components/minisites/common/BasicDetailsDomain';
import BasicDetailsImageAvatarUpload from '../../components/minisites/common/BasicDetailsImageAvatarUpload';
import TransferList from '../../components/minisites/TransferList';
import NotificationsHeader from '../../components/minisites/common/NotificationsHeader';
import NotificationsFooter from '../../components/minisites/common/NotificationsFooter';
import SelectContentSearch from '../../components/minisites/common/SelectContentSearch';

/**
 * region for hepers*/
import typing from '../../helpers/typing';


/**
 * region for constans*/


class UpdateMiniSite extends Component {
    componentDidMount() {
        const idMinisite = this.props.match.params.id;
        let dataRequest = {
            idMinisite: idMinisite
        };

        this.props.fetchMiniSiteGetMiniSite(dataRequest);
        this.props.fetchMiniSiteSearchNotifications();
    }

    fetchMiniSiteSetSearch(searchingEventsField) {
        let dataRequest = {
            description: searchingEventsField
        };
        this.props.fetchMiniSiteSearchEvents(dataRequest);
    }

    fetchMiniSiteSetAttributesHtml(attributes, error, id) {
        const dataNotofications = this.props.dataNotofications;
        if (id === "header") {
            dataNotofications.errors.header = error;
        }
        if (id === "footer") {
            dataNotofications.errors.footer = error;
        }
        Object.assign(dataNotofications, attributes);
        this.props.fetchMiniSiteSetAttributesHtml(dataNotofications);
    }

    fetchMiniSiteSetAttributes(attributes, error, id) {
        const dataBasicDetails = this.props.dataBasicDetails;
        if (id === "name") {
            dataBasicDetails.errors.name = error;
        }
        if (id === "subdomain") {
            dataBasicDetails.errors.subdomain = error;
        }
        if (id === "domain") {
            dataBasicDetails.errors.domain = error;
        }
        Object.assign(dataBasicDetails, attributes);
        this.props.fetchMiniSiteSetAttributes(dataBasicDetails);
    }

    fetchMiniSiteSetSelectListEventsNew(searchResultListEvents, selectListEventsNew, errors) {
        this.props.fetchMiniSiteSetSelectListEventsNew(searchResultListEvents, selectListEventsNew, errors);
    }

    fetchMiniSiteSetSelectListNotifications(searchResultListNotifications, selectNotifications, errors) {
        this.props.fetchMiniSiteSetSelectListNotifications(searchResultListNotifications, selectNotifications, errors);
    }

    fetchMiniSiteSetSave() {
        let dataBasicDetails = this.props.dataBasicDetails;
        let errorName, errorSubdomain, errorDomain = false;

        if (typing.isEmpty(dataBasicDetails.name)) {
            dataBasicDetails.errors.name = true;
            errorName = true;
        } else {
            dataBasicDetails.errors.name = false;
            errorName = false;
        }

        if (typing.isEmpty(dataBasicDetails.subdomain)) {
            dataBasicDetails.errors.subdomain = true;
            errorSubdomain = true;
        } else {
            if (!typing.isUrlFriendly(dataBasicDetails.subdomain)) {
                dataBasicDetails.errors.subdomain = true;
                errorSubdomain = true;
            } else {
                dataBasicDetails.errors.subdomain = false;
                errorSubdomain = false;
            }
        }

        if (typing.isEmpty(dataBasicDetails.domain)) {
            dataBasicDetails.errors.domain = true;
            errorDomain = true;
        } else {
            dataBasicDetails.errors.domain = false;
            errorDomain = false;
        }

        const selectListEventsNew = this.props.dataSelectContent.selectListEventsNew;
        if (!errorName && !errorDomain && !errorSubdomain && (!typing.isDefined(selectListEventsNew) || selectListEventsNew.length > 0)) {
            const { history } = this.props;
            this.props.fetchMiniSiteUpdateMiniSite(history,this.props);
        }
    }

    render() {
        const { classes } = this.props;
        const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

        //Texfields
        const { name, subdomain, domain, minisiteLogoUrl, minisiteLogo } = this.props.dataBasicDetails;
        const errorsDataBasicDetails = this.props.dataBasicDetails.errors;

        const { footer, header } = this.props.dataNotofications;
        const errorsDataNotofications = this.props.dataNotofications.errors;

        //Data Dropdowns
        const { selectListDomain } = this.props;

        //TrasfersLists
        const { searchResultListEventsNew } = this.props;
        const selectListEventsNew = this.props.dataSelectContent.selectListEventsNew;
        const errorsSelectListEventsNew = this.props.dataSelectContent.errors.selectListEvents;

        const { searchResultListNotifications } = this.props;
        const selectListNotifications = this.props.dataNotificationContent.selectListNotifications;
        const errorsSelectListNotifications = this.props.dataNotificationContent.errors.selectListNotifications;

        let backoffficeUrl = this.props.backoffficeUrl + "/Event_Modify.asp?code";
        return (
            <Grid className={classes.contentAll}
                container>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Paper className={fixedHeightPaper}>
                        <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={4}>
                            <Grid container item xs={12} sm={12} md={6} lg={6}>
                                <Grid container className={classes.marginTitle}>
                                    <Grid item>
                                        <Typography variant="h6" gutterBottom>Basic Info</Typography>
                                    </Grid>
                                    <Grid item xs className={classes.backgroundMiddle}>
                                        <div className={classes.backgroundDiv} ></div>
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.marginSeccions}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <BasicDetailsName
                                            name={name}
                                            nameError={errorsDataBasicDetails.name}
                                            onAttributeUpdate={this.fetchMiniSiteSetAttributes.bind(this)}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.marginSeccions} spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} lg={6}>
                                        <BasicDetailsSubDomain
                                            name={subdomain}
                                            nameError={errorsDataBasicDetails.subdomain}
                                            onAttributeUpdate={this.fetchMiniSiteSetAttributes.bind(this)} />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={6}>
                                        <BasicDetailsDomain
                                            name={domain}
                                            nameError={errorsDataBasicDetails.domain}
                                            selectListDomain={selectListDomain}
                                            onAttributeUpdate={this.fetchMiniSiteSetAttributes.bind(this)} />
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.marginSeccions}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <SelectContentSearch
                                            onAttributeUpdate={this.fetchMiniSiteSetSearch.bind(this)} />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <TransferList
                                            selectListLeft={searchResultListEventsNew}
                                            selectListRight={selectListEventsNew}
                                            errors={errorsSelectListEventsNew}
                                            showErrors={true}
                                            enableLink={true}
                                            baseLink={backoffficeUrl}
                                            onAttributeUpdate={this.fetchMiniSiteSetSelectListEventsNew.bind(this)}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.marginTitle}>
                                    <Grid item>
                                        <Typography variant="h6" gutterBottom>Image</Typography>
                                    </Grid>
                                    <Grid item xs className={classes.backgroundMiddle}>
                                        <div className={classes.backgroundDiv} ></div>
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.marginSeccions}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <BasicDetailsImageAvatarUpload
                                            minisiteLogoUrl={minisiteLogoUrl}
                                            minisiteLogoFile={minisiteLogo}
                                            onAttributeUpdateImage={this.fetchMiniSiteSetAttributes.bind(this)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={6} lg={6} >
                                <Grid container className={classes.marginTitle}>
                                    <Grid item>
                                        <Typography variant="h6" gutterBottom>Notifications</Typography>
                                    </Grid>
                                    <Grid item xs className={classes.backgroundMiddle}>
                                        <div className={classes.backgroundDiv} ></div>
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.marginSeccions}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <TransferList
                                            selectListLeft={searchResultListNotifications}
                                            selectListRight={selectListNotifications}
                                            errors={errorsSelectListNotifications}
                                            showErrors={false}
                                            onAttributeUpdate={this.fetchMiniSiteSetSelectListNotifications.bind(this)}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.marginSeccions}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <NotificationsHeader
                                            header={header}
                                            error={errorsDataNotofications.header}
                                            validate={false}
                                            onAttributeUpdateHtml={this.fetchMiniSiteSetAttributesHtml.bind(this)}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.marginSeccions}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <NotificationsFooter
                                            footer={footer}
                                            error={errorsDataNotofications.footer}
                                            validate={false}
                                            onAttributeUpdateHtml={this.fetchMiniSiteSetAttributesHtml.bind(this)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={12} lg={12} >
                                <Grid container spacing={2} direction="row" justify="flex-end" alignItems="flex-start">
                                    <Grid item xs={2} sm={2} md={2} lg={2}>
                                        <Button
                                            component={Link}
                                            to={"/LayoutMiniSite/List"}
                                            id="buttonCancel"
                                            size="small"
                                            fullWidth
                                            variant="outlined">
                                            Cancel
                                            </Button>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2}>
                                        <Button
                                            id="buttonSave"
                                            size="small"
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={this.fetchMiniSiteSetSave.bind(this)}>
                                            Save
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                    {this.props.pending && <Backdrop className={classes.backdrop} open={true}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    }
                </Grid>
            </Grid >
        );
    }
}
UpdateMiniSite.propTypes = {
    classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const idMinisite = state.MiniSitesReducers.idMinisite;
    const dataBasicDetails = state.MiniSitesReducers.dataBasicDetails;
    const dataSelectContent = state.MiniSitesReducers.dataSelectContent;
    const dataNotofications = state.MiniSitesReducers.dataNotofications;
    const dataNotificationContent = state.MiniSitesReducers.dataNotificationContent;
    const selectListDomain = state.MiniSitesReducers.selectListDomain;
    const searchResultListEventsNew = state.MiniSitesReducers.searchResultListEventsNew;
    const searchResultListNotifications = state.MiniSitesReducers.searchResultListNotifications;
    const backoffficeUrl = state.MiniSitesReducers.backoffficeUrl;
    const pending = state.MiniSitesReducers.pending;
    return {
        idMinisite,
        dataBasicDetails,
        dataSelectContent,
        dataNotofications,
        dataNotificationContent,
        selectListDomain,
        searchResultListEventsNew,
        searchResultListNotifications,
        backoffficeUrl,
        pending
    };
}

const mapDispatchToProps = dispatch => {
    return {
        fetchMiniSiteGetIsValidSubdomain: (subdomain) => dispatch(MiniSitesActions.fetchMiniSiteGetIsValidSubdomain(subdomain)),
        fetchMiniSiteGetMiniSite: (dataRequest) => dispatch(MiniSitesActions.fetchMiniSiteGetMiniSite(dataRequest)),
        fetchMiniSiteSetAttributes: (attributes, error, id) => dispatch(MiniSitesActions.fetchMiniSiteSetAttributes(attributes, error, id)),
        fetchMiniSiteSetAttributesHtml: (attributes, error, id) => dispatch(MiniSitesActions.fetchMiniSiteSetAttributesHtml(attributes, error, id)),
        fetchMiniSiteSearchEvents: (dataRequest) => dispatch(MiniSitesActions.fetchMiniSiteSearchEvents(dataRequest)),
        fetchMiniSiteSetSelectListEventsNew: (searchResultListEvents, selectListEventsNew, errors) => dispatch(MiniSitesActions.fetchMiniSiteSetSelectListEventsNew(searchResultListEvents, selectListEventsNew, errors)),
        fetchMiniSiteSearchNotifications: () => dispatch(MiniSitesActions.fetchMiniSiteSearchNotifications()),
        fetchMiniSiteSetSelectListNotifications: (searchResultListNotifications, selectListNotifications, errors) => dispatch(MiniSitesActions.fetchMiniSiteSetSelectListNotifications(searchResultListNotifications, selectListNotifications, errors)),
        fetchMiniSiteUpdateMiniSite: (history, dataRequest) => dispatch(MiniSitesActions.fetchMiniSiteUpdateMiniSite(history, dataRequest)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(updateMiniSiteStyle)(withRouter(UpdateMiniSite)));